const DEFAULT_DEV_API_BASE_URL = 'http://localhost:8080';

// OAuth callback path - must match OIDC provider redirect_uris configuration
export const OAUTH_CALLBACK_PATH = '/oauth/complete';

export const config = {
  apiBaseUrl:
    import.meta.env.VITE_API_BASE_URL ||
    (import.meta.env.DEV ? DEFAULT_DEV_API_BASE_URL : ''),
  oidc: {
    issuer: import.meta.env.VITE_OIDC_ISSUER || '',
    clientId: import.meta.env.VITE_OIDC_CLIENT_ID || '',
    authorizeEndpoint: import.meta.env.VITE_OIDC_AUTHORIZE_ENDPOINT || '',
    scopes: import.meta.env.VITE_OIDC_SCOPES || '',
  },
  isDev: import.meta.env.DEV,
};

/**
 * Fetch server configuration from the API if not provided via env vars.
 * In dev mode, the API defaults to http://localhost:8080, so running the
 * FastAPI server locally is all that's needed — no .env file required.
 */
export async function loadServerConfig(): Promise<void> {
  if (
    config.oidc.issuer &&
    config.oidc.clientId &&
    config.oidc.authorizeEndpoint &&
    config.oidc.scopes
  ) {
    return;
  }

  const configUrl = `${config.apiBaseUrl}/auth/config`;

  let response: Response;
  try {
    response = await fetch(configUrl);
  } catch {
    throw new Error(
      `Could not reach API server at ${configUrl}. ` +
        'Start the API server or set VITE_OIDC_ISSUER + VITE_OIDC_CLIENT_ID.'
    );
  }
  if (!response.ok) {
    throw new Error(
      `Failed to load config from API (${response.status}): ${response.statusText}`
    );
  }

  const data = await response.json();
  config.oidc.issuer = config.oidc.issuer || data.issuer;
  config.oidc.clientId = config.oidc.clientId || data.client_id;
  config.oidc.authorizeEndpoint =
    config.oidc.authorizeEndpoint || data.authorization_endpoint;
  config.oidc.scopes = config.oidc.scopes || data.scopes;
}
